/**
=========================================================
* Otis Admin PRO - v2.0.1
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Otis Admin PRO React base styles
import borders from "assets/theme/base/borders";
import colors from "assets/theme/base/colors";

const { white, primary } = colors;
const { borderWidth } = borders;

export default {
  styleOverrides: {
    root: {
      color: primary.light,
      transition: "all 200ms linear",

      "&.Mui-active": {
        color: primary.main,
      },

      "&.Mui-completed": {
        color: primary.main,
      },
    },

    alternativeLabel: {
      top: "14%",
      left: "-50%",
      right: "50%",
    },

    line: {
      borderWidth: `${borderWidth[6]} !important`,
      borderColor: "currentColor",
      opacity: 0.75,
    },
  },
};
